export default __webpack_public_path__ + "static/media/Artist6.be9e1cce.svg";